import { api } from './client';

export interface SyncLabelFilters {
  buyer_stage: string[];
  serp_type: string[];
  kw_type: string[];
  groups: string[];
  tags: string[];
}

export interface SyncLabel {
  id: number;
  keyword_norm: string;
  project_id: string | null;
  locale: string;
  group_path: string | null;
  labels: Record<string, unknown>;
  tags: string[];
  source_app: string | null;
  updated_at: string;
}

export const syncLabelsApi = {
  getFilters: (projectId?: string) =>
    api.get<SyncLabelFilters>(
      `/webhook/sync-labels/filters${projectId ? `?project_id=${encodeURIComponent(projectId)}` : ''}`
    ),

  getByKeyword: (keywordNorm: string) =>
    api.get<{ labels: SyncLabel[]; count: number }>(
      `/webhook/sync-labels?keyword_norm=${encodeURIComponent(keywordNorm)}`
    ),

  getAll: (projectId?: string) =>
    api.get<{ labels: SyncLabel[]; count: number }>(
      `/webhook/sync-labels${projectId ? `?project_id=${encodeURIComponent(projectId)}` : ''}`
    ),
};
